'use client';

import { useHeader } from '@larvitu/shared/react/context/feature-header-context';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { BoxProps } from '@mui/material';

/**
 * @deprecated - use ToolbarOffset instead
 */
export const HeaderPlaceholder = styled( Box, {
  shouldForwardProp: (prop) => prop !== 'height',
} )<BoxProps>( () => {
  const { height } = useHeader();

  return {
    paddingTop: height,
  };
} );
